export const SuccessIcon = () => (
  <svg width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.6667 18.4667V20C36.6646 23.594 35.5008 27.0911 33.3489 29.9697C31.1969 32.8483 28.1721 34.9541 24.7256 35.9732C21.279 36.9922 17.5954 36.8698 14.2241 35.6243C10.8528 34.3788 7.9744 32.0768 6.01825 29.0618C4.06209 26.0467 3.13296 22.4801 3.36944 18.8939C3.60592 15.3076 4.99532 11.8939 7.33045 9.16179C9.66557 6.4297 12.8213 4.52564 16.327 3.73357C19.8326 2.94151 23.5004 3.30389 26.7833 4.76667"
      stroke="#28AE25"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.6667 6.66669L20 23.35L15 18.35"
      stroke="#28AE25"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
